// extracted by mini-css-extract-plugin
export default {"container":"TZ2QmDYt43lM0eX_euEQ","imageBlock":"IxQ0YZGO_uOlkt4Fpyhj","infoBlock":"pNotSGuzzpYufqSpwdrq"};